import { useEffect } from 'react';
import { BasketItem } from '../types';
import { BASKET_UPDATE } from '../constants';

function isBasketUpdateEvent(e: Event): e is CustomEvent<BasketItem[]> {
  return 'detail' in e && Array.isArray((e as CustomEvent).detail);
}

export const useBasketUpdate = (load: () => void, update: (basket: BasketItem[]) => void): void => {
  useEffect(() => {
    const handleBasketUpdate = (e: Event) => {
      if (isBasketUpdateEvent(e)) {
        update(e.detail);
      }
    };

    document.body.addEventListener(BASKET_UPDATE, handleBasketUpdate);
    load();

    return () => {
      document.body.removeEventListener(BASKET_UPDATE, handleBasketUpdate);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
